import { Link } from "react-router-dom";

const genres = ["剧情", "悬疑", "科幻", "古装", "家庭", "犯罪"];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading text-lg font-black text-background-50">
                国产精品久久
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              汇聚高清国产电影与电视剧的资源信息平台，按类型、年份快速查找，帮你发现值得一看的国产影视佳作。
            </p>
            <p className="mt-4 text-xs text-background-400">
              本站内容均为虚构演示数据，不提供播放与下载服务。
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold text-background-50">快速导航</h4>
            <ul className="space-y-2.5 text-sm">
              {[
                { to: "/", label: "首页推荐" },
                { to: "/category", label: "影视分类" },
                { to: "/search", label: "全网搜索" },
                { to: "/about", label: "关于我们" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-background-300 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold text-background-50">热门类型</h4>
            <ul className="flex flex-wrap gap-2">
              {genres.map((genre) => (
                <li key={genre}>
                  <Link
                    to={`/category?genre=${encodeURIComponent(genre)}`}
                    className="inline-flex rounded-md border border-background-700 px-2.5 py-1 text-xs text-background-300 transition-colors hover:border-accent-400 hover:text-accent-300 cursor-pointer"
                  >
                    {genre}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold text-background-50">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-mail-line text-sm" />
                </span>
                service@guochanjingpin99.demo
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-wechat-line text-sm" />
                </span>
                微信公众号：国产精品久久
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-time-line text-sm" />
                </span>
                内容更新：每日 10:00 / 20:00
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-bookmark-3-line", "ri-play-circle-line"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="flex h-8 w-8 items-center justify-center rounded-md bg-background-50/10 text-background-200"
                  >
                    <i className={`${icon} text-sm`} />
                  </span>
                ),
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-700 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 国产精品久久 · 本站为影视内容展示演示站点，所有作品与数据均为虚构示例。</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="cursor-pointer hover:text-background-100">
              版权声明
            </Link>
            <Link to="/about" className="cursor-pointer hover:text-background-100">
              服务条款
            </Link>
            <Link to="/category" className="cursor-pointer hover:text-background-100">
              资源索引
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}